// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reversed-container>*[data-v-d27e30a6]:first-child{order:2}.reversed-container>*[data-v-d27e30a6]:last-child{order:1}div.flex-row[data-v-d27e30a6]{gap:var(--spacing-s)}div.flex-column[data-v-d27e30a6]{gap:var(--spacing-l)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
